@<template>
  <div>
    <Form ref="loginData" :model="loginData" :rules="ruleInline">
      <div class="landing">
        <div class="landing-p">
          <p>{{$t('i.login.examinationLanding')}}</p>
        </div>
        <div class="text-box">
          <div class="languageBox">
            <div class="language">
              <span>{{ $t("i.login.language")}}：</span>
            </div>
            <div class="language-select">
              <Select :placeholder="loginData.defaultLangLabel" @on-change="languageSwitching">
                <Option v-for="item in loginData.languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
          </div>
          <div class="typeCompany">
            <div class="typeCompanyText">
              <span class="">{{$t('i.personalInformation.typeOfCompany')}}：</span>
            </div>
            <div class="companyType">
              <FormItem prop="company">
                  <Select v-model="loginData.company">
                    <Option v-for="(typeCompany,index) in typeCompanys"
                            :key="typeCompany.entry_code" :value="typeCompany.entry_code">{{ typeCompany.entry_name }}</Option>
                  </Select>
              </FormItem>
            </div>
          </div>
        </div>

        <div class="text-box">
          <div class="user-name">
            <span>{{ $t("i.login.username")}}：</span>
          </div>
          <div class="name-text">
            <FormItem prop="user">
              <i-input type="text" v-model="loginData.user" placeholder="Username" style="height: 20px">
                <Icon type="ios-person-outline" slot="prepend"></Icon>
              </i-input>
            </FormItem>
          </div>
        </div>

        <div class="text-box">
          <div class="password">
            <span>{{ $t("i.login.password")}}：</span>
          </div>
          <div class="password-text">
            <FormItem prop="password">
              <i-input type="password" v-model="loginData.password" placeholder="Password">
                <Icon type="ios-lock-outline" slot="prepend"></Icon>
              </i-input>
            </FormItem>
          </div>
        </div>

        <div class="text-box">
          <div class="verification-code">
            <span>{{ $t("i.login.verificationCode")}}：</span>
          </div>
          <div class="verification-code-text">
            <FormItem prop="captcha">
              <i-input type="text" v-model="loginData.captcha" style="width: 100px"></i-input>
            </FormItem>
          </div>
          <div class="verification-code-img">
            <img :src="verificationCodeURI"
                 v-on:click="verificationCodeURI  = Constants.serverURL+'/validateCode?_='+new Date().getTime();"
                 alt="验证码">
          </div>
        </div>

        <div class="text-box">
          <div class="text-btn-box">
            <FormItem>
              <Button type="primary" @click="handleSubmit('loginData')">{{$t('i.login.land')}}</Button>
              <Button type="primary" @click="toForgetPasswd">{{$t('i.login.forgetThePassword')}}</Button>
            </FormItem>
          </div>
        </div>
      </div>
    </Form>
    <div v-show="flag2" class="forgetPasswordPopup">
      <forget-password ref="forgetPasswd" @closeForgetPasswd="closeForgetPasswd"></forget-password>
    </div>
    <div v-show="flag" :closable="false" :mask-closable="false" class="changePasswordPopup">
      <change-password @closeChangePasswd="closeChangePasswd"></change-password>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js/crypto-js'
  import ChangePassword from "../../changePassword/changePassword";
  import ForgetPassword from "../../forgetPassword/forgetPassword";
  export default {
    name: "login",
    components:{
      ForgetPassword,
      ChangePassword
    },
    data () {
      return {
        flag: false,
        flag2: false,
        typeCompanys:[],
        loginData: {
          company: '',
          user: '',
          password: '',
          captcha:'',
          defaultLangValue: localStorage.getItem("defaultLangValue"),
          defaultLangLabel: localStorage.getItem("defaultLangLabel"),
          languageList: JSON.parse(localStorage.getItem("defaultLangList")),
        },
        verificationCodeURI: this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login0",
        ruleInline: {
          company: [
            { required: true, message: this.$t('i.login.company'), trigger: 'change'}
          ],
          user: [
            { required: true, message: this.$t('i.login.user_message'), trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: this.$t('i.login.verificationCode_message'), trigger: 'blur' }
          ],
          password: [
            { required: true, message: this.$t('i.login.password_message'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' }
          ]
        }
      }
    },
    // message: 'The password length cannot be less than 6 bits',
    methods: {
      async companyList(){
        const json = await this.RequestUtil.request("/companyList");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.typeCompanys = json.datas;
          }
        }
      },
      closeChangePasswd(val,isClose){
        this.flag = isClose == '1' ? true : false;
        this.verificationCodeURI = this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login3";
        this.loginData.password = '';
        this.loginData.captcha = '';
        this.$emit('setLoginCheck', val);
      },
      closeForgetPasswd(val){
        this.flag2 = val == '1' ? true : false;
        this.$emit('setLoginCheck', val);
      },
      handleSubmit (name) {
        this.$refs[name].validate(async (valid) => {
          if (valid) {
            let url = "/dialogLogin?username=" + this.loginData.user;
            url += "&password=" + CryptoJS.SHA256(this.loginData.password);
            url += "&captcha=" + this.loginData.captcha;
            url += "&company=" + this.loginData.company;
            const json = await this.RequestUtil.request(url);
            if(json) {
              if (json.statusCode == this.Constants.statusCode.ok) {
                localStorage.setItem("curJsSessionId",json.datas.curJsSessionId);
                localStorage.setItem("userInfo",JSON.stringify(json.datas));
                const isInitPasswd = json.datas.isInitPasswd;
                const passwdExpired = json.datas.passwdExpired;
                if(isInitPasswd == '1'){
                  this.flag = true;
                  this.$Message.warning({content: this.$t('i.login.isInitPasswd'),duration: 5});
                  return;
                }else if(passwdExpired == '1'){
                  const passwdExpired = json.datas.passwdExpired;
                  this.flag = true;
                  this.$Message.warning({content: this.$t('i.login.passwdExpired'),duration: 5});
                  return;
                }else{
                  this.$emit('setLoginCheck', '1');
                }
              }else{
                this.verificationCodeURI = this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login2";
                localStorage.removeItem("userInfo");
              }
            }
          }
        })
      },
      toForgetPasswd(){
        this.flag2 = true;
        this.$refs.forgetPasswd.refreshCaptcha();
      },
      verificationCodeURIClick(){
        this.verificationCodeURI  = this.Constants.serverURL+'/validateCode?_='+Date.now()+"&t_=login1";
      },
      languageSwitching(value){
        this.$i18n.locale = value;
        localStorage.setItem("defaultLangValue",value);
        setTimeout(()=>{
          const langList = [
            {
              value: 'zh_CN',
              label: this.$t('i.login.language_zh')
            },
            {
              value: 'ja_JP',
              label: this.$t('i.login.language_ja')
            }
          ];
          this.loginData.languageList = langList;
          let defaultLangLabel = this.$t('i.login.language_zh');
          if(value == "ja_JP"){
            defaultLangLabel = this.$t('i.login.language_ja');
          }
          this.loginData.defaultLangLabel = defaultLangLabel;
          console.log("defaultLangLabel",defaultLangLabel);
          localStorage.setItem("defaultLangLabel",defaultLangLabel);
          localStorage.setItem("defaultLangList",JSON.stringify(langList));
          this.$router.go(0);
        },300);
      },
    },
    mounted(){
      let defaultLangValue = localStorage.getItem("defaultLangValue");
      if(!defaultLangValue){
        defaultLangValue = 'zh_CN';
        localStorage.setItem("defaultLangValue","zh_CN");
        localStorage.setItem("defaultLangLabel","中文");
        const langList = [
          {
            value: 'zh_CN',
            label: '中文'
          },
          {
            value: 'ja_JP',
            label: '日语'
          }
        ];
        localStorage.setItem("defaultLangList",JSON.stringify(langList));
      }
      this.$i18n.locale = defaultLangValue;
      this.loginData.defaultLangValue = localStorage.getItem("defaultLangValue");
      this.loginData.defaultLangLabel =  localStorage.getItem("defaultLangLabel");
      this.loginData.languageList = JSON.parse(localStorage.getItem("defaultLangList"));
      this.companyList();
    }
  }
</script>

<style scoped>
  .landing{
    width: 288px;
    height: 300px;
    border: 1px solid #000;
    border-radius: 10px;
    float: left;
    margin-top: 10px;
    background-color: #fff;
  }

  .landing-p{
    width: 286px;
    height: 50px;
    text-align: center;
    line-height: 60px;
  }
  .landing-p p{
    font-size: 18px;
    color: #5f5f5f;
  }

  .text-box{
    width: 285px;
    height: 32px;
    margin-bottom: 18px;
  }
  .typeCompany{
    width: 150px;
    height: 32px;
    float: left;
    /*background-color: pink;*/
  }
  .language-select {
    width: 70px;
    height: 32px;
    float: left;
  }
  .language{
    width: 40px;
    height: 32px;
    line-height: 32px;
    float: left;
    text-align: right;
  }
  .user-name,
  .password,
  .verification-code
  {
    width: 80px;
    height: 32px;
    float: left;
    line-height: 32px;
    text-align: right;
  }
  .ivu-form-item{
    margin-bottom: 0px!important;
  }

  .name-text,
  .password-text,
  .verification-code-text
  {
    float: left;
  }
  .typeCompanyText{
    width: 77px;
    height: 32px;
    float: left;
    line-height: 32px;
    text-align: right;
  }
  .companyType{
    width: 70px;
    float: right;
    margin-right: 3px;
  }
  .languageBox{
    width: 110px;
    height: 32px;
    float: left;
    margin-left: 10px;
  }
  .verification-code-img{
    float: left;
    margin-left: 8px;
    margin-top: 2px;
  }
  .verification-code-img img{
    width: 90px;
    height: 30px;
    border-radius: 5px;
    cursor: pointer;
  }
  .text-btn-box{
    width: 285px;
    height: 32px;
    text-align: center;
  }
  .text-box button:nth-child(1){
    height: 32px;
  }
  .text-box button:nth-child(2){
    height: 32px;
    margin-left: 10px;
  }
  .changePasswordPopup{
    position: absolute;
    z-index: 111;
  }
  .forgetPasswordPopup{
    position: absolute;
    z-index: 110;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/login-old.vue